import adminMainReduser from './admin/adminMainReduser';
import loginReducer from './auth/loginReducer';
import systemReducer from './customer/systemReducer';
import userReducer from './auth/userReducer';
import configSystem from "./customer/configSystemReducer";
import notificationUser from "./customer/NotificationUserReducer";
import agencyReducer from './admin/agencyReducer';
import infoAdminReducer from "./admin/infoAdmin";
let redux = require('redux');

const rootReducer = redux.combineReducers({
    login: loginReducer,
    user: userReducer,
    agency: agencyReducer,
    system: systemReducer,
    adminMain: adminMainReduser,
    configSystem: configSystem,
    notificationUser: notificationUser,
    infoAdmin: infoAdminReducer,
})

// const rootReducer = redux.createStore(allReducer);

export default rootReducer;